import React, { useEffect, useRef, useState } from "react";
import { useMsal, useAccount, useMsalAuthentication } from "@azure/msal-react";
import { http, httpAD, httpNFR } from "./http-common";
import { loginRequest } from "./authConfig";
import usePageTracking from "utils/PageTracking";
import { getModuleNameFromPath } from "utils/utils";
 
const RequestInterceptor = ({ children }) => {
  const { instance, accounts } = useMsal();
  const [user , setUser] =useState(JSON.parse(window?.sessionStorage?.getItem("BAT_USER")))
  const account = useAccount(accounts[0]);
  const { pageVisits } = usePageTracking();
  const functionalityRef=useRef();

  useEffect(()=>{
    const functionality = getModuleNameFromPath(pageVisits[pageVisits.length - 1]?.path || "");
    if(functionality!==undefined && functionality!=="" && functionality!=null){
      functionalityRef.current=functionality
    }
  }, [pageVisits])

  let tenantId = "";
  if (user) {
    if (user?.userAttribute == "Global") {
      tenantId = "Global";
      localStorage.setItem("isLoggedIn", "true");
    } else {
      tenantId = user?.countryCode;
      localStorage.setItem("isLoggedIn", "true");
    }
  }
 
  // Add a response interceptor
  http.interceptors.response.use(
    (response) => {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with successful response data
      if( response?.config?.url.includes("/user-management/logged-in-user?")  && user == null){
        let user = response?.data?.response
        window.sessionStorage.setItem("BAT_USER", JSON.stringify(response?.data?.response));
        setUser(user)
      }
      return response;
    },
    (error) => {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Handle errors here
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        // console.error("Response error:", error.response.data);
        if (error.response.data.statusCode == 401) {
          // return getValidToken(config)
          window.open(window?.location?.href, "_self");
        }
        // You can add more sophisticated error handling here, such as showing notifications or alerts
      } else if (error.request) {
        // The request was made but no response was received
        // console.error("Request error:", error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        // console.error("Error:", error.status);
      }
      // console.error("Config:", error.config);
      // You can return a Promise.reject() if you want to propagate the error further
      return Promise.reject(error);
    }
  );
  // Add a request interceptor
 
  http.interceptors.request.use(async (config, error) => {
    attachUserName(config)
    return getValidToken(config);
  });
  const attachUserName = async (config) => {
    try {
      // config.headers["userPrincipalName"] = user?.userName;
      config.headers["userPrincipalName"] = accounts[0]?.username;
      return config
    } catch (ex) {
      console.log(ex)
    }
  }
 
  httpNFR.interceptors.request.use(async (config, error) => {
    attachUserName(config)
    return getValidToken(config);
  });
   
  const getValidToken = async (config) => {
    try {
      if (!account) {
        throw Error("No active account! Verify a user has been signed in.");
      }
      const response = await instance.acquireTokenSilent({
        ...loginRequest,
        account,
      });
 
      if (response) {
        const bearer = `Bearer ${response.accessToken}`;
        config.headers.Authorization = bearer;
        config.headers["Functionality-Name"]= functionalityRef.current;
 
        // commenting Tenant for now
 
 
        if (tenantId) {
 
          if (
            (/\/user(\/|$)/.test(config.url)) || ( config.url.includes("profile") && !config.url.includes("profiles") ) || config.url.includes("user-action-tracker") ||
            config.url.includes("role-management") || config.url.includes("user-management") || config.url.includes("delegation") ||
            config.url.includes("conflict-indicator") || config.url.includes("role-functionality-management") ||  (/\/level0(-export)?(\/|$)/.test(config.url))
          ) {
            // alert("Down")
            config.headers["X-TenantID"] = "Global";
          } else if (config.url.includes("/capture-activity")) {
            config.headers["X-TenantID"] = tenantId;
            if (!config.url.includes("action=Read")) {
              config.headers["Functionality-Name"] = null;
            }
          } else {
            if (config.url.includes("/crop-stage-calendar")) {
              if (user?.profiles?.some(profile => profile.profileName === "Global ESG Admin" || profile.profileName === "Global ESG Back office")) {
                config.headers["X-TenantID"] = config?.headers?.apiCountryCode;
              } else {
                config.headers["X-TenantID"] = user?.countryCode;
              }
              config.headers["Functionality-Name"]="Crop Stage Calendar"
            } else {
              if (config.url.includes("/cropYears") && config?.headers?.apiCountryCode != undefined
               || config.url.includes("/surveyApprover")
               ||  (config.url.includes("/hierarchy-drop-down") && config?.headers?.apiCountryCode != undefined)
               || (config.url.includes("/hierarchy/isApprover") && config?.headers?.apiCountryCode != undefined)
               ||  (config.url.includes("/cropStages") && config?.headers?.apiCountryCode != undefined)
               || (config.url.includes("/picklist") && config?.headers?.apiCountryCode != undefined)
               || (config.url.includes("/season-registration") && config?.headers?.apiCountryCode != undefined)
               || (config.url.includes("/module/dropdown") && config?.headers?.apiCountryCode != undefined)
               || (config.url.includes("/pending-translations") && config?.headers?.apiCountryCode != undefined)
               || (config.url.includes("/active-reportStaticTranslations") && config?.headers?.apiCountryCode != undefined)
               || ( (/\/level1(-export)?(\/|$)/.test(config.url)) && config?.headers?.apiCountryCode != undefined)
               || (config.url.includes("/ crop-stage-calendar-drop-down") && config?.headers?.apiCountryCode != undefined)
              ) {
                config.headers["X-TenantID"] = config?.headers?.apiCountryCode;
              } else {
                config.headers["X-TenantID"] = tenantId;
              }
            }
          }
        }
        // config.headers["X-TenantID"] = "Global";
        return config;
      }
    } catch (error) {
      // console.log("Silent token acquisition failedd:", error);
      // Method to redirect to microsoft in case of refresh token expires to get new access and refresh token.
      // const silenntLogin = await instance.ssoSilent({
      //     ...loginRequest,
      //     account,
      // });
 
      // Method to popup to microsoft in case of refresh token expires to get new access and refresh token.
      // if (error instanceof InteractionRequiredAuthError) {
      instance
        .acquireTokenRedirect({
          ...loginRequest,
          account,
        })
        .then(function (accessTokenResponse) {
          // Acquire token interactive success
          let accessToken = accessTokenResponse.accessToken;
          const bearer = `Bearer ${accessToken}`;
          config.headers.Authorization = bearer;
          return config;
        })
        .catch(function (error) {
          // Acquire token interactive failure
          // console.log(error);
          window.open(window?.location?.href, "_self");
          // alert("Please close the tab and open application in new tab")
        });
      // }
    }
  };
  /* eslint-enable no-param-reassign */
  return <>{children}</>;
};
 
export default RequestInterceptor;
 